import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
var SIZES = {
  small: {
    topMargin: 8 * 3,
    bottomMargin: 8 * 7
  },
  medium: {
    topMargin: 8 * 4,
    bottomMargin: 8 * 8
  },
  large: {
    topMargin: 8 * 5,
    bottomMargin: 8 * 9
  },
  xlarge: {
    topMargin: 8 * 6,
    bottomMargin: 8 * 10
  }
};
var borderStyles = css(["padding:18px 12px;border-radius:10px;box-shadow:rgb(0 0 0 / 0.2) 0 1px 2px 0,rgb(0 0 0 / 0.2) 0 0 3px 0;"]);
export var Inner = styled.section.withConfig({
  displayName: "Inner",
  componentId: "sc-h8h0xj-0"
})(["", " ", " ", " > a{svg{display:none;vertical-align:sub;}}", ";"], function (_ref) {
  var _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    size = _ref.size;
  return bottomMargin && "margin-bottom: ".concat(SIZES[size].bottomMargin, "px;");
}, function (_ref2) {
  var _ref2$topMargin = _ref2.topMargin,
    topMargin = _ref2$topMargin === void 0 ? false : _ref2$topMargin,
    size = _ref2.size;
  return topMargin && "margin-top: ".concat(SIZES[size].topMargin, "px;");
}, function (_ref3) {
  var _ref3$withBorder = _ref3.withBorder,
    withBorder = _ref3$withBorder === void 0 ? false : _ref3$withBorder;
  return withBorder && borderStyles;
}, minMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    a {\n      svg {\n        display: inline\n      }\n    }\n  "]))));
export var TabsBlock = styled.div.withConfig({
  displayName: "Inner__TabsBlock",
  componentId: "sc-h8h0xj-1"
})(["margin-top:-12px;"]);